module.exports = __webpack_public_path__ + "static/media/video_1.61108ac.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_7/video_1.mp4
// module id = v56E
// module chunks = 0